import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useWishlistStore = create(
  persist(
    (set, get) => ({
      items: [],

      addToWishlist: (product) => {
        const items = get().items;
        const exists = items.find((item) => item._id === product._id);

        if (!exists) {
          set({ items: [...items, product] });
          return true;
        }
        return false;
      },

      removeFromWishlist: (productId) => {
        set({ items: get().items.filter((item) => item._id !== productId) });
      },

      toggleWishlist: (product) => {
        const items = get().items;
        const exists = items.find((item) => item._id === product._id);

        if (exists) {
          get().removeFromWishlist(product._id);
          return false; // Removed
        } else {
          get().addToWishlist(product);
          return true; // Added
        }
      },

      isInWishlist: (productId) => {
        return get().items.some((item) => item._id === productId);
      },

      clearWishlist: () => {
        set({ items: [] });
      },

      getWishlistCount: () => {
        return get().items.length;
      },
    }),
    {
      name: 'wishlist-storage',
    }
  )
);

export default useWishlistStore;
